import React from "react";
import "url-search-params-polyfill";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import { Switch } from "react-router-dom";
import * as icons from "common/icons";
import OfflinePoller from "components/OfflinePoller";
import ScrollTopRoute from "components/ScrollTopRoute";
import Page from "components/Page";
import PageHead from "components/PageHead";
import PageBody from "components/PageBody";
import ActionLink from "components/ActionLink";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import Tabs from "components/new/Tabs";
import TabsItem from "components/new/TabsItem";
import UserGuides from "./UserGuides";
import MySupportTickets from "./MySupportTickets";
import AddSupportTicketModal from "./AddSupportTicketModal";
import { openSupportModal, closeSupportModal } from "./_actions";

class Support extends React.Component {
    addTicket = () => {
        this.props.openSupportModal("AddSupportTicketModal");
    };

    render() {
        const { location, modal } = this.props;
        let header = process.env.REACT_APP_HEADER === "green" ? "Header--green" : "";
        header = process.env.REACT_APP_HEADER === "orange" ? "Header--orange" : header;
        return (
            <div className={`react-page ${modal ? "modal-is-open" : ""}`}>
                <header className={`Header ${header}`}>
                    <div className="Header-logo">
                        <ActionLink className="Header-logo-sm" id="home_small">
                            <img src={icons.logoSmall()} alt="Overseer logo" />
                        </ActionLink>
                        <ActionLink className="Header-logo-lg" id="home_large">
                            <img src={icons.logo()} alt="Overseer logo" />
                        </ActionLink>
                    </div>
                    <div className="UtilityNav">
                        <OfflinePoller />
                    </div>
                </header>
                <Page>
                    {true && (
                        <PageHead>
                            <div className="FarmTitle">
                                <div className="FarmTitle-heading">
                                    <span className="FarmTitle-name">Support</span>
                                </div>
                            </div>
                            <div className="PageHead-actions">
                                <ActionLink id="add-ticket" className="IconLink--arrow-plus" onClick={this.addTicket}>
                                    Request support
                                </ActionLink>
                            </div>
                        </PageHead>
                    )}
                    <PageBody>
                        <Panel title="My Support" actions={<ActionLink id="close" className="IconLink--cross u-textWhite" onClick={() => window.close()}></ActionLink>} skyBlue>
                            <PanelBody>
                                <Panel>
                                    <PanelBody>
                                        <Tabs>
                                            <TabsItem title="My Support Tickets" to={{ pathname: "/support", search: location.search }} exact />
                                            <TabsItem title="User Guides" to={{ pathname: "/support/guides", search: location.search }} exact />
                                        </Tabs>
                                        <Switch>
                                            <ScrollTopRoute exact path="/support" render={(p) => <MySupportTickets addTicket={this.addTicket} />} />
                                            <ScrollTopRoute exact path="/support/guides" render={(p) => <UserGuides />} />
                                        </Switch>
                                    </PanelBody>
                                </Panel>
                            </PanelBody>
                        </Panel>
                    </PageBody>
                </Page>
                <footer className="Footer u-print-none">
                    <div className="Container">
                        <ul className="Footer-nav">
                            <li>
                                <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerTermsOfUse.pdf`} rel="noopener noreferrer" target="_blank">
                                    Terms of use
                                </a>
                            </li>
                            <li>
                                <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerPrivacyPolicy.pdf`} rel="noopener noreferrer" target="_blank">
                                    Privacy policy
                                </a>
                            </li>
                        </ul>
                        Overseer &copy; 2018 | v{process.env.REACT_APP_VERSION.split("+")[0]}
                    </div>
                </footer>
                {modal === "AddSupportTicketModal" && <AddSupportTicketModal />}
            </div>
        );
    }
}

export default compose(
    withAppContext,
    withActions({ openSupportModal, closeSupportModal }),
    withState((state) => {
        return {
            modal: state.support.modal,
        };
    })
)(Support);
